import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { AuthService, LanguageService, UserService, UtilsService } from "@services";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { AppState } from "./app.reducer";
import * as fromAuthActions from "./store/actions/auth.actions";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["../assets/app.scss"],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  subscription: Subscription;
  constructor(
    private router: Router,
    private store: Store<AppState>,
    public translate: TranslateService,
    private langService: LanguageService,
    public utilsService: UtilsService,
    private authService: AuthService,
    private userService: UserService,
  ) { }
  ngAfterViewInit() {
  }

  ngOnInit() {

    this.store.select("auth").subscribe((u: any) => {
      if (u && u.isAuthenticated) {
        if (!(u.user?.user?.passwordLastChanged || u.user.passwordLastChanged) && u.user.accessType !== "employee") {
          const action = new fromAuthActions.LogoutAction();
          this.store.dispatch(action);
          this.authService.userCompanyPlan = null;
          localStorage.removeItem;
        }
        if (!this.authService.userFilters && (u?.user?.user?.uuid || u?.user?.uuid)) {
          this.userService.getPoliciesUser(u.user.user? u.user.user.uuid : u.user.uuid).subscribe(
            (policy: any) => {
              this.authService.userFilters = policy.filters;
            },
            (err) => {}
          );
        }
      }
    })

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        (<any>window).ga("set", "page", event.urlAfterRedirects);
        (<any>window).ga("send", "pageview");
      }
    });

    const lang = this.translate.getBrowserLang();
    // TODO regionalizar i18n
    //const lang = this.langService.getLanguage();
    this.translate.setDefaultLang("es");
    if (lang) {
      this.langService.saveLanguage(lang);
      this.translate.use(this.translate.getBrowserLang());
    } else {
      // const browserLang: string = this.translate.getBrowserLang();
      // const auxLang = browserLang.match(/en|es/) ? browserLang : "es";
      // TODO regionalizar i18n
      /* const auxLang =
        navigator.languages != null && navigator.languages.length > 0
          ? navigator.languages[0]
          : navigator.language ? navigator.language : "es"; 
        this.langService.saveLanguage(auxLang);
          */
      this.langService.saveLanguage(this.translate.getBrowserLang());
      this.translate.use(this.translate.getBrowserLang());
    }

    this.subscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => window.scrollTo(0, 0));

    const action = new fromAuthActions.PopulateAction();
    this.store.dispatch(action);
  }

  navigate(route: string) {
    this.router.navigate([route]);
  }

  checkOS() {

  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
